export type RequestLogEntry = {
  method: string;
  url: string;
  status: number | null;
  statusText?: string;
  error: string;
  code?: string;
  timestamp: number;
  requestData?: string;
  requestHeaders?: Record<string, string>;
  responseData?: string;
  responseHeaders?: Record<string, string>;
};

const MAX_ENTRIES = 50;
const logs: RequestLogEntry[] = [];

export function addRequestLog(entry: RequestLogEntry): void {
  logs.push(entry);
  if (logs.length > MAX_ENTRIES) {
    logs.shift();
  }
}

export function getRequestLogs(): RequestLogEntry[] {
  return [...logs].reverse();
}
